export default {
  // ヒーローセクション
  hero: {
    title: '機能',
    subtitle: 'あなたとペットに提供するすべての強力な機能を探索'
  },
  
  // ステータスバッジ
  status: {
    available: '利用可能',
    beta: 'ベータ版'
  },
  
  // コア機能セクション
  core: {
    badge: 'コア機能',
    title: '必須ツール',
    description: 'ペットケアをシンプルで効果的にする基本機能',
    
    petProfiles: {
      title: 'ペットプロフィール',
      description: '各ペットの完全なデジタルプロフィールを作成し、すべての重要情報を含む',
      feature1: '包括的な情報',
      feature2: '写真アップロード',
      feature3: '医療記録',
      feature4: '行動メモ'
    },
    
    secureSharing: {
      title: '安全な共有',
      description: '暗号化リンクを通じて承認された人とペット情報を安全に共有',
      feature1: 'ユニークな共有リンク',
      feature2: '読み取り専用アクセス',
      feature3: 'ログイン不要',
      feature4: 'プライバシー保護'
    },
    
    schedule: {
      title: 'スケジュール管理',
      description: '給餌、投薬、活動スケジュールを設定および追跡',
      feature1: '給餌スケジュール',
      feature2: '投薬リマインダー',
      feature3: '運動追跡',
      feature4: '獣医予約'
    },
    
    healthTracking: {
      title: '健康追跡',
      description: 'ペットの健康指標と医療履歴を監視',
      feature1: '体重追跡',
      feature2: '予防接種履歴',
      feature3: 'アレルギー管理',
      feature4: '獣医記録'
    },
    
    mobileFriendly: {
      title: 'モバイルフレンドリー',
      description: 'あらゆるデバイスで完璧に動作するレスポンシブデザイン',
      feature1: 'レスポンシブデザイン',
      feature2: 'タッチ最適化',
      feature3: 'クロスプラットフォーム',
      feature4: 'オフラインデータキャッシュ'
    },
    
    multiLanguage: {
      title: '多言語サポート',
      description: '繁体字中国語、英語、日本語インターフェースをサポート',
      feature1: '中国語サポート',
      feature2: '英語サポート',
      feature3: '日本語サポート',
      feature4: '即時言語切り替え'
    }
  },
  
  // 高度な機能セクション
  advanced: {
    badge: '高度な機能',
    title: '強力なツール',
    description: '上級ユーザー向けのプロフェッショナル機能',
    
    security: {
      title: 'セキュリティ強化',
      description: '業界標準の暗号化技術でペットデータを保護し、承認されたユーザーのみがアクセス可能'
    },
    
    multiUser: {
      title: 'マルチユーザーアクセス',
      description: '複数の家族や介護者が同時にペット情報を閲覧し、一緒にケアに参加'
    },
    
    editing: {
      title: '完全な編集機能',
      description: '写真、医療記録、スケジュールを含むペット情報をいつでも更新'
    },
    
    cloudSync: {
      title: 'クラウド同期',
      description: 'クラウドに自動同期し、データの安全性とあらゆるデバイスからのアクセスを確保'
    },
    
    location: {
      title: '位置追跡',
      description: 'ペットの現在位置と獣医クリニック情報を記録し、緊急時に便利'
    },
    
    performance: {
      title: 'パフォーマンス最適化',
      description: '複数のペットを管理しても、高速読み込みとスムーズなユーザー体験'
    }
  },
  
  // 近日公開セクション
  upcoming: {
    badge: '近日公開',
    title: '今後の機能',
    description: 'さらにエキサイティングな機能を開発中、お楽しみに',
    
    notifications: {
      title: 'スマート通知',
      description: 'ペットのスケジュールに基づいてスマートリマインダーを受信し、重要なタスクを見逃さない'
    },
    
    backup: {
      title: '自動バックアップと復元',
      description: 'ペットデータを自動的にバックアップし、いつでも以前のバージョンに復元'
    },
    
    calendar: {
      title: 'カレンダー統合',
      description: 'カレンダーアプリと同期し、ペット活動を日常スケジュールに追加'
    },
    
    community: {
      title: 'コミュニティ機能',
      description: '他のペットオーナーと経験を交換し、ケアのヒントを共有'
    },
    
    healthTrends: {
      title: '健康トレンド分析',
      description: 'チャートとレポートでペットの健康トレンドを分析し、早期に問題を発見'
    },
    
    vetIntegration: {
      title: '獣医クリニック統合',
      description: '獣医クリニックシステムと直接接続し、医療記録を自動同期'
    }
  },
  
  // CTAセクション
  cta: {
    title: 'すべての機能を探索する準備はできましたか？',
    subtitle: 'これらの強力な機能を今すぐ使い始めて、ペットケアを簡単に'
  }
};